module.exports = __webpack_public_path__ + "assets/img/Trade-Glass-Depot-Website.aef9de78.webp";